var render = function render(_c, _vm) {
  return _c(
    "wa-question-and-answer",
    {
      attrs: {
        id: "what-the-customer-may-do",
        title: "What the Customer May Do",
      },
    },
    [
      _c("template", { slot: "copy" }, [
        _c("h4", { staticClass: "h5 margin-top-2xl" }, [
          _vm._v("Manage Creators"),
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v("\n      The\n      "),
          _c("em", [_vm._v("Customer's")]),
          _vm._v(" "),
          _c("strong", [_vm._v("Seat Count")]),
          _vm._v(
            '\n      is the number of "seats" the Customer bought through the\n      '
          ),
          _c("em", [_vm._v("Web Store")]),
          _vm._v(
            ". The Customer may appoint up to that many individuals as\n      "
          ),
          _c("strong", [_vm._v("Creators")]),
          _vm._v("\n      under this agreement at any given time. The\n      "),
          _c("em", [_vm._v("Customer")]),
          _vm._v("\n      may remove people as\n      "),
          _c("em", [_vm._v("Creators")]),
          _vm._v(
            "\n      under this agreement, to make room for others within the\n      "
          ),
          _c("em", [_vm._v("Customer's Seat Count")]),
          _vm._v(". To remove "),
          _c("em", [_vm._v("Creators")]),
          _vm._v(", the\n      "),
          _c("em", [_vm._v("Customer")]),
          _vm._v(
            "\n      must first ensure that they stop using Pro Icons and remove copies of\n      "
          ),
          _c("em", [_vm._v("Pro Icons")]),
          _vm._v("\n      and\n      "),
          _c("em", [_vm._v("Pro Software")]),
          _vm._v("\n      from their computers.\n    "),
        ]),
        _vm._v(" "),
        _c("h4", { staticClass: "h5 margin-top-2xl" }, [
          _vm._v("Download, Backup, and Share with Creators"),
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v("\n      The\n      "),
          _c("em", [_vm._v("Customer")]),
          _vm._v("\n      may download\n      "),
          _c("em", [_vm._v("Pro Icons")]),
          _vm._v("\n      and\n      "),
          _c("em", [_vm._v("Pro Software")]),
          _vm._v("\n      from the\n      "),
          _c("em", [_vm._v("Web Store")]),
          _vm._v(", make backups, and share copies with their "),
          _c("em", [_vm._v("Creators")]),
          _vm._v(".\n    "),
        ]),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }